// The owner's draft preview routes (/preview/...), shown in the phone editor's iframe.
export function isOwnerPreview(route) {
    return !!route?.matched?.some((match) => match.meta?.ownerPreview);
}
